// Vendor/third-party libraries
// This pack contains all third-party dependencies

// Polyfills
require("url-polyfill");
require("core-js/stable");
require("regenerator-runtime/runtime");
require('whatwg-fetch');

// jQuery MUST be loaded and exposed globally FIRST
const $ = require('jquery');
global.$ = global.jQuery = window.$ = window.jQuery = $;

// Now load Bootstrap and Select2 - they will find jQuery on window
require('bootstrap');
require('select2');

// Rails - expose globally for use in controllers
const Rails = require("@rails/ujs");
Rails.start();
window.Rails = Rails;

if (document.head.hasAttribute("data-turbolinks-pilot")) {
  require("turbolinks").start();
}

require("@rails/activestorage").start();

// Third-party libraries
require("@fortawesome/fontawesome-free/css/all.css");
const Dropzone = require('dropzone');
// Dropzone might be exported as .default in some versions
const DropzoneConstructor = Dropzone.default || Dropzone;
DropzoneConstructor.autoDiscover = false;
window.Dropzone = DropzoneConstructor;  // Expose globally so controllers use the same instance
require("chartkick");

require('../stylesheets/vendor');

// Utility functions (must load before controllers)
require('./utilities');

// Configure Select2
$.fn.select2.amd.define('select2/i18n/nl',[],require("select2/src/js/select2/i18n/nl"));
$.fn.select2.amd.define('select2/i18n/fr',[],require("select2/src/js/select2/i18n/fr"));
$.fn.select2.amd.define('select2/i18n/de',[],require("select2/src/js/select2/i18n/de"));
$.fn.select2.defaults.set("theme", "bootstrap");

